import React, { useEffect, useState } from "react";
import api, { fmtDateTime } from "../lib/api";
import { Field, StatusPill } from "../components/Primitives";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

const empty = { customer_name: "", phone: "", car_id: "", scheduled_at: "", status: "scheduled", notes: "" };

export default function TestDrives() {
  const [items, setItems] = useState([]);
  const [cars, setCars] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);

  const load = async () => {
    const { data } = await api.get("/test-drives"); setItems(data);
  };
  useEffect(() => {
    load();
    api.get("/showroom/cars").then(({ data }) => setCars(data));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/test-drives", form);
      toast.success("Scheduled"); setOpen(false); setForm(empty); load();
    } catch { toast.error("Failed"); }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div>
          <div className="kk-overline">04 · 04</div>
          <h2 className="font-display text-2xl uppercase">Test Drives</h2>
        </div>
        <button className="kk-btn-primary" onClick={() => setOpen(true)} data-testid="new-td"><Plus size={14}/> Schedule</button>
      </div>

      <table className="kk-table">
        <thead><tr><th>Customer</th><th>Phone</th><th>Car</th><th>When</th><th>Status</th></tr></thead>
        <tbody>
          {items.map((t) => (
            <tr key={t.id}>
              <td>{t.customer_name}</td>
              <td>{t.phone}</td>
              <td>{(cars.find((c) => c.id === t.car_id) || {}).model || "—"}</td>
              <td className="font-mono">{fmtDateTime(t.scheduled_at)}</td>
              <td><StatusPill status={t.status} /></td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={5} className="text-center py-8 text-[var(--kk-muted)]">No test drives scheduled.</td></tr>}
        </tbody>
      </table>

      {open && (
        <div className="fixed inset-0 bg-black/30 z-50 flex justify-end" onClick={() => setOpen(false)}>
          <form onSubmit={save} onClick={(e) => e.stopPropagation()} className="w-full max-w-lg bg-[var(--kk-surface)] p-8 overflow-y-auto">
            <div className="flex items-center justify-between"><h2 className="font-display text-2xl uppercase">Schedule Test Drive</h2><button type="button" onClick={() => setOpen(false)}><X /></button></div>
            <div className="grid grid-cols-2 gap-5 mt-5">
              <Field label="Customer"><input className="kk-input" required value={form.customer_name} onChange={upd("customer_name")} /></Field>
              <Field label="Phone"><input className="kk-input" required value={form.phone} onChange={upd("phone")} /></Field>
              <Field label="Car">
                <select className="kk-input" required value={form.car_id} onChange={upd("car_id")}>
                  <option value="">—</option>
                  {cars.map((c) => <option key={c.id} value={c.id}>{`${c.make} ${c.model}`}</option>)}
                </select>
              </Field>
              <Field label="When"><input className="kk-input" type="datetime-local" required value={form.scheduled_at} onChange={upd("scheduled_at")} /></Field>
              <div className="col-span-2"><Field label="Notes"><textarea className="kk-input" value={form.notes} onChange={upd("notes")} /></Field></div>
            </div>
            <button className="kk-btn-primary mt-6" type="submit">Schedule</button>
          </form>
        </div>
      )}
    </div>
  );
}
